
import { PRODUCTION_ORIGIN } from "@consts";

export default {
	name: "SocialSharing",
	props: {
		articleTitle: {
			type: String,
			default: "",
		},
		articleImage: {
			type: String,
			default: "",
		},
	},
	computed: {
		articleURL() {
			return `${PRODUCTION_ORIGIN}${this.$route.fullPath}`;
		},
		items() {
			return [
				{
					link: `https://www.facebook.com/sharer/sharer.php?display=page&u=${this.articleURL}&quote=${this.articleTitle} via WordFinder by YourDictionary`,
					iconClass: "wficon-facebook-filled",
					title: "Share on Facebook",
					aria: "Facebook",
				},
				{
					link: `https://twitter.com/share?text=${this.articleTitle}&via=YourDictionary&url=${this.articleURL}`,
					iconClass: "wficon-x-black",
					title: "Share on Twitter",
					aria: "Twitter",
				},
				{
					link: `http://www.pinterest.com/pin/create/bookmarklet/?url=${this.articleURL}&media=${this.articleImage}&description=${this.articleTitle} via WordFinder by @yourdictionary`,
					iconClass: "wficon-pinterest-filled",
					title: "Share on Pinterest",
					aria: "Pinterest",
				},
				{
					link: `mailto:?subject=${this.articleTitle}&body=${this.articleURL}`,
					iconClass: "wficon-mail-filled",
					title: "Send via mail",
					aria: "Mail",
				},
			];
		},
	},
};
